import { render, staticRenderFns } from "./MyToolbarItem.vue?vue&type=template&id=2589cc9a&scoped=true"
import script from "./MyToolbarItem.vue?vue&type=script&lang=js"
export * from "./MyToolbarItem.vue?vue&type=script&lang=js"
import style0 from "./MyToolbarItem.vue?vue&type=style&index=0&id=2589cc9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2589cc9a",
  null
  
)

export default component.exports